// extracted by mini-css-extract-plugin
module.exports = {"fakePaymentMethod":"_3jH8i","withBorder":"_3c2Sl"};